import {WriteButton} from '../../common/buttons/WriteActions';
import {Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography} from '@mui/material';
import {useState} from 'react';
import {useAppTranslation} from '@mybake/ui/hooks/useAppTranslation';

interface Props {
    open: boolean;
    customerName: string;
    isDeleting: boolean;
    onClose: () => void;
    onDelete: () => void;
    error?: string;
}

export const DeleteCustomerDialog = ({open, customerName, isDeleting, onClose, onDelete, error}: Props) => {
    const [confirmationText, setConfirmationText] = useState('');
    const {t} = useAppTranslation();
    const isValid = customerName.length > 0 && confirmationText.trim() === customerName.trim();

    const handleClose = () => {
        setConfirmationText('');
        onClose();
    };

    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xs">
            <DialogTitle>{t('common:delete')}</DialogTitle>
            <DialogContent>
                <Typography sx={{mb: 2}}>
                    {t('customers:delete_customer_confirmation')}
                </Typography>
                <Typography color="error" fontWeight={600} sx={{mb: 2}}>{customerName}</Typography>
                {error && <Alert severity="error" sx={{mb: 2}}>{error}</Alert>}
                <TextField
                    autoFocus
                    fullWidth
                    label={t('customers:customer_name')}
                    value={confirmationText}
                    onChange={(event) => setConfirmationText(event.target.value)}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>{t('common:cancel')}</Button>
                <WriteButton color="error" variant="contained" disabled={!isValid || isDeleting} onClick={onDelete}>
                    {t('common:delete')}
                </WriteButton>
            </DialogActions>
        </Dialog>
    );
};
